import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FichaLiquidacionService } from 'src/app/services/liquidacion/ficha-liquidacion.service';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { claseMarca, fechaLiq, puedeVerLiquidacion } from 'src/app/services/liquidacion/marcas';
import { guardarArchivo } from 'src/app/utils/descargar';

/**
 * CONSULTAS DE LIQUIDACIÓN (cambio 9; maqueta vistas 9, 10, 11 y 20). Lo que ya pasó, por rango de fechas.
 *
 *   Historial    (9.1) las liquidaciones con número y, distinguidas, las del cierre sin número (pasadas a mañana,
 *                por liquidar) — decisión de Mario 08-oct. Filtros, cifras, Excel y cada una abre sus pagarés y su historia.
 *   Auditoría    (9.3) cada cierre con lo liquidado, pasado a mañana y no procesado; su detalle, Excel e historia;
 *                avisos y las reglas de control tal como están configuradas (no un texto fijo).
 *   Cuentas      el libro de cada cuenta de origen: lo que salió, lo comprometido, la historia y el Excel para cruzar (CTA-01 a 07).
 *   Calendario   (9.4) su propio componente, liquidacion-calendario: semana, mes o año, como gráfico o lista (FLU-01 a 12).
 *   Consolidado  (9.2) por comercio: crédito, descuento, servicio, neto, pagado y pendiente; cada uno abre su detalle por
 *                pagaré, que cuadra con el crédito (Ángela 06-oct). Por vencimiento o emisión; Excel con sus hojas.
 *   Buscar       crédito o pago (EST-01 a 06; maqueta traza-credito-pago, Mario 12-oct): su marca de ya liquidado y
 *                la traza día por día. Acepta ?venta=CODE o ?pago=REF para llegar enlazado desde otras pantallas.
 * Las reglas viven en el núcleo (modules/liquidacion/dominio/historial.js).
 */
@Component({
  selector: 'app-liquidacion-consultas',
  templateUrl: './liquidacion-consultas.component.html'
})
export class LiquidacionConsultasComponent implements OnInit {
  pestana: 'historial' | 'consolidado' | 'auditoria' | 'calendario' | 'cuentas' | 'buscar' = 'historial';
  cargando = false;
  error = '';

  readonly ESTADOS = [
    { v: 'PAGADA', t: 'Pagada' }, { v: 'APROBADA', t: 'Aprobada sin pagar' }, { v: 'NO_PROCESADA', t: 'No procesada' },
    { v: 'PASADA_A_MANANA', t: 'Pasada a mañana' }, { v: 'POR_LIQUIDAR', t: 'Por liquidar' },
  ];
  f = { desde: '', hasta: '', por: 'corte', comercio: '', estado: '', metodo: '', origen: '' };
  r: any = { filas: [], resumen: {} };
  abierta: string | null = null;
  d: any = null;
  origenes: any[] = [];
  pagina = 0;
  readonly POR = 20;

  constructor(private ruta: ActivatedRoute, private router: Router, private liq: LiquidacionService, private merchants: MerchantService,
    private _auth: AuthService, public fichaLiq: FichaLiquidacionService) { }

  ngOnInit(): void {
    this.atajo('mes', false);
    this.atajoC('prox', false);
    this.fa = { desde: this.mover(this.hoy(), -29), hasta: this.hoy() };
    this.ft = { ...this.ft, desde: this.mover(this.hoy(), -6), hasta: this.hoy() };
    this.liq.cuentasOrigen('MANUAL').then((x) => { this.origenes = (x && x.cuentas) || []; }).catch(() => { });
    this.ruta.queryParamMap.subscribe((q) => {
      const v = q.get('vista');
      const venta = q.get('venta'), pago = q.get('pago');
      if (q.get('comercio')) this.f.comercio = q.get('comercio') as string;   // desde la ficha del comercio → su historial
      this.pestana = venta || pago ? 'buscar'
        : v === 'consolidado' || v === 'auditoria' || v === 'calendario' || v === 'cuentas' || v === 'buscar' ? v : 'historial';
      this.error = '';
      if (this.pestana === 'buscar') {
        void this.cargarGuia();
        if (venta || pago) { this.b = { tipo: pago ? 'pago' : 'venta', texto: (pago || venta) as string }; this.buscarMarca(); }
        return;
      }
      if (this.pestana === 'calendario' || this.pestana === 'cuentas') return;   // leen lo suyo (liquidacion-calendario, liquidacion-cuentas)   // el calendario lee lo suyo (liquidacion-calendario)
      if (this.pestana === 'consolidado') this.buscarC();
      else if (this.pestana === 'auditoria') this.buscarA();
      else this.buscar();
    });
  }

  verPestana = (p: 'historial' | 'consolidado' | 'auditoria' | 'calendario' | 'cuentas' | 'buscar'): void => { this.router.navigate([], { queryParams: { vista: p, cuenta: null, venta: null, pago: null }, queryParamsHandling: 'merge' }); };

  // ══ soporte al comercio: una sola caja y transferencias por fecha y monto (SOP-01 a 04; Mario, 14-oct) ══
  q = '';
  rs: any = null;          // { texto, tipos, resultados }
  guia: any[] = [];
  cargandoS = false;
  errorS = '';
  ft: { desde: string; hasta: string; comercio: string; monto: string; margen: string } = { desde: '', hasta: '', comercio: '', monto: '', margen: '0.50' };
  rt: any = null;
  cargandoT = false;
  errorT = '';
  readonly tituloTipo: Record<string, string> = { VENTA: 'Venta', VARIAS_VENTAS: 'Varias ventas', LIQUIDACION: 'Liquidación', CUENTA_POR_PAGAR: 'Documento',
    PAGO_COMERCIO: 'Pago al comercio', REFERENCIA: 'Transferencia', LOTE: 'Lote', PAGO_CLIENTE: 'Pago del cliente' };

  cargarGuia = async (): Promise<void> => {
    if (this.guia.length || !this.puede) return;
    try { this.guia = (await this.liq.buscarSoporte('')).guia || []; } catch (e) { this.guia = []; }
  };
  /** SOP-01: reconoce lo pegado. Si es una sola venta o un solo pago del cliente, abre su estado aquí mismo. */
  buscarS = async (): Promise<void> => {
    const t = (this.q || '').trim();
    this.rs = null; this.errorS = '';
    if (!t) return;
    this.cargandoS = true;
    try {
      this.rs = await this.liq.buscarSoporte(t);
      const r = this.rs.resultados || [];
      if (r.length === 1 && r[0].tipo === 'VENTA') this.abrirVenta(r[0].venta);
      else if (r.length === 1 && r[0].tipo === 'PAGO_CLIENTE') { this.b = { tipo: 'pago', texto: r[0].pago }; this.irA(); }
      else if (r.length === 1 && r[0].liquidacion) this.fichaLiq.abrir(r[0].liquidacion);
    } catch (e: any) { this.errorS = e?.error?.msg || 'No se pudo buscar.'; } finally { this.cargandoS = false; }
  };
  irAResultado = (r: any): void => {
    if (r.tipo === 'VENTA') this.abrirVenta(r.venta);
    else if (r.tipo === 'PAGO_CLIENTE') { this.b = { tipo: 'pago', texto: r.pago }; this.irA(); }
    else if (r.liquidacion) this.fichaLiq.abrir(r.liquidacion);
    else if (r.lote) this.router.navigate(['/console/liquidacion'], { queryParams: { lote: r.lote } });
  };
  /** SOP-03: «el 10/10 me llegó X». */
  buscarT = async (): Promise<void> => {
    this.rt = null; this.errorT = '';
    if (!this.ft.desde || !this.ft.hasta) { this.errorT = 'Indica desde y hasta.'; return; }
    this.cargandoT = true;
    try { this.rt = await this.liq.transferencias(this.ft); } catch (e: any) { this.errorT = e?.error?.msg || 'No se pudieron leer las transferencias.'; } finally { this.cargandoT = false; }
  };

  // ══ buscar crédito o pago (EST-01 a 06; maqueta traza-credito-pago, escenarios 1, 2 y 3) ══
  /** EST-08: estricto, como el núcleo (sin RBAC el núcleo responde 403). */
  get puede(): boolean { return puedeVerLiquidacion(this._auth); }
  b: { tipo: 'venta' | 'pago'; texto: string } = { tipo: 'venta', texto: '' };
  v: any = null;           // la venta (compra de deuda o cobranza)
  p: any = null;           // el pago con sus aplicaciones
  cargandoB = false;
  errorB = '';
  readonly claseMarca = claseMarca;
  fechaC = (iso: string | null): string => fechaLiq(iso, true);

  /** Lleva la búsqueda a la URL (?venta= o ?pago=): el enlace se comparte y el atrás funciona. */
  irA = (): void => {
    const t = (this.b.texto || '').trim();
    if (!t) return;
    const qp: any = { vista: 'buscar', venta: null, pago: null };
    qp[this.b.tipo] = t;
    if (this.ruta.snapshot.queryParamMap.get(this.b.tipo) === t) { this.buscarMarca(); return; }   // la misma URL no vuelve a emitir
    this.router.navigate([], { queryParams: qp, queryParamsHandling: 'merge' });
  };
  abrirVenta = (code: string | null): void => { if (code) { this.b = { tipo: 'venta', texto: code }; this.irA(); } };

  buscarMarca = async (): Promise<void> => {
    this.v = null; this.p = null; this.errorB = '';
    if (!this.puede) { this.errorB = 'Para ver la liquidación hace falta el permiso «liquidacion.consultar».'; return; }
    const t = (this.b.texto || '').trim();
    if (!t) return;
    this.cargandoB = true;
    try {
      if (this.b.tipo === 'pago') this.p = await this.liq.estadoPago(t);
      else this.v = await this.liq.estadoVenta(t);
    } catch (e: any) {
      this.errorB = e?.error?.msg || (e?.status === 404 ? `No se encontró ${this.b.tipo === 'pago' ? 'el pago' : 'la venta'} ${t}.` : 'No se pudo leer el estado.');
    } finally { this.cargandoB = false; }
  };

  /** EST-06 (pago): el núcleo no trae traza del pago; se arma con sus aplicaciones (cada cierre y su LIQ) y lo que falta va punteado. */
  get trazaPago(): { fecha: string | null; titulo: string; detalle: string; pendiente?: boolean }[] {
    if (!this.p) return [];
    const t: any[] = [];
    for (const a of this.p.aplicaciones || []) {
      const donde = `${a.venta || '—'}${a.cuota != null ? ` · cuota ${a.cuota}` : ''}`;
      t.push({ fecha: this.p.pago?.fecha || null, titulo: `Pago aplicado a ${donde}`, detalle: `${this.num(a.monto)} USD${a.desconciliado ? ` · luego desconciliado${a.registro ? ` (${a.registro})` : ''}` : ''}${a.aviso ? ` · ${a.aviso}` : ''}` });
      if (a.modelo === 'COMPRA_DEUDA' || a.estado === 'NO_APLICA') { t.push({ fecha: null, titulo: 'No aplica', detalle: 'En compra de deuda los pagos del cliente no se liquidan al comercio (lo cobra CrediTotal).' }); continue; }
      if (a.estado === 'RETENIDO') { t.push({ fecha: null, titulo: 'Retenido por la salud de los cobros', detalle: 'No entra al cierre hasta que se libere.' }); continue; }
      if (a.cierre) t.push({ fecha: a.dia_cierre || null, titulo: `Entró al cierre ${a.cierre}`, detalle: a.neto != null ? `neto ${this.num(a.neto)}` : '' });
      if (a.liquidacion) t.push({ fecha: null, titulo: `Liquidación ${a.liquidacion}`, detalle: a.pagado ? 'Pagada al comercio' : 'Por pagar al comercio' });
      else t.push({ fecha: null, titulo: 'Tanda, liquidación y pago al comercio', detalle: a.cierre ? 'Pendiente: si el día cierra sin aprobar, el pago vuelve a entrar al cierre siguiente.' : 'Pendiente: todavía no entra a un cierre.', pendiente: true });
      if (a.reverso) t.push({ fecha: a.reverso.dia || null, titulo: `Reverso ${this.num(-Math.abs(a.reverso.monto))}${a.reverso.liquidacion ? ` en ${a.reverso.liquidacion}` : ' · por descontar'}`, detalle: 'Se desconcilió después de liquidado: se descuenta en la liquidación siguiente (DES-10).' });
    }
    return t;
  }
  abs = (n: any): number => Math.abs(Number(n) || 0);
  private num = (n: any): string => (Number(n) || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  /** Ancho de cada tramo de la barra de avance (cobranza), en % del crédito. */
  tramo = (monto: number): number => { const c = Number(this.v?.totales?.credito) || 0; return c > 0 ? Math.max(0, Math.min(100, (Number(monto) || 0) / c * 100)) : 0; };

  // ══ auditoría de cierres (9.3; vista 11) ══
  fa = { desde: '', hasta: '' };
  ra: any = { cierres: [], avisos: { cuentas_por_verificar: [] }, reglas: [] };
  cargandoA = false;
  abiertoDia: string | null = null;
  da: any = null;

  buscarA = async (): Promise<void> => {
    this.cargandoA = true; this.error = ''; this.abiertoDia = null; this.da = null;
    try { this.ra = await this.liq.auditoriaCierres(this.fa); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer la auditoría.'; this.ra = { cierres: [], avisos: { cuentas_por_verificar: [] }, reglas: [] }; }
    finally { this.cargandoA = false; }
  };
  abrirDia = async (a: any): Promise<void> => {
    if (this.abiertoDia === a.dia) { this.abiertoDia = null; this.da = null; return; }
    this.abiertoDia = a.dia; this.da = null;
    try { this.da = await this.liq.auditoriaCierre(a.dia); } catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el cierre.'; }
  };
  /** AUD-05: el Excel del cierre es el de auditoría (4.4), guardado con su huella en el núcleo. */
  excelCierre = async (dia: string): Promise<void> => {
    try {
      const blob = await this.liq.descargarAuditoria(dia);
      guardarArchivo(blob, `auditoria-cierre-${dia.replace(/-/g, '')}.xlsx`);
    } catch (e: any) { this.error = 'No se pudo descargar el Excel del cierre.'; }
  };
  /** ACT-09: el acta de un día cerrado (la misma cada vez). */
  bajarActa = async (dia: string, formato: 'pdf' | 'xlsx'): Promise<void> => {
    try {
      const blob = await this.liq.actaDelDia(dia, formato);
      guardarArchivo(blob, `acta-cierre-${dia.replace(/-/g, '')}.${formato}`);
    } catch (e: any) {
      // con responseType blob, el mensaje del núcleo viene dentro de un Blob
      let msg = ''; try { msg = JSON.parse(await e?.error?.text()).msg; } catch (x) { }
      this.error = msg || 'No se pudo descargar el acta.';
    }
  };
  estadoCierre = (s: string): { texto: string; clase: string } => ({
    EN_PREPARACION: { texto: 'En preparación', clase: 'kb-badge-alerta' }, ENVIADO_A_PAGO: { texto: 'Enviado a pago', clase: 'kb-badge-exito' },
    NO_APROBADO: { texto: 'No aprobado', clase: 'kb-badge-peligro' }, SIN_VENCIMIENTOS: { texto: 'Sin vencimientos', clase: 'kb-badge-neutro' },
  } as any)[s] || { texto: s, clase: 'kb-badge-neutro' };

  // ══ consolidado (9.2; vista 10) ══
  fc = { desde: '', hasta: '', por: 'vence', comercio: '' };
  rc: any = { comercios: [], pagares: [], total: {}, omitidos: [] };
  cargandoC = false;
  abiertoCom: string | null = null;

  /** Atajos de la maqueta: hoy, próximos 7 días, últimos 7 días, este mes. */
  atajoC = (k: 'hoy' | 'prox' | '7' | 'mes', buscar = true): void => {
    const h = this.hoy();
    if (k === 'hoy') { this.fc.desde = h; this.fc.hasta = h; }
    if (k === 'prox') { this.fc.desde = h; this.fc.hasta = this.mover(h, 6); }
    if (k === '7') { this.fc.desde = this.mover(h, -6); this.fc.hasta = h; }
    if (k === 'mes') { this.fc.desde = `${h.slice(0, 7)}-01`; const d = new Date(`${h.slice(0, 7)}-01T12:00:00Z`); d.setUTCMonth(d.getUTCMonth() + 1); d.setUTCDate(0); this.fc.hasta = d.toISOString().slice(0, 10); }
    if (buscar) this.buscarC();
  };
  esAtajoC = (k: 'hoy' | 'prox' | '7' | 'mes'): boolean => {
    const g = { ...this.fc }; this.atajoC(k, false); const ok = g.desde === this.fc.desde && g.hasta === this.fc.hasta; this.fc.desde = g.desde; this.fc.hasta = g.hasta; return ok;
  };

  buscarC = async (): Promise<void> => {
    this.cargandoC = true; this.error = ''; this.abiertoCom = null;
    try { this.rc = await this.liq.consolidado(this.fc); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo armar el consolidado.'; this.rc = { comercios: [], pagares: [], total: {}, omitidos: [] }; }
    finally { this.cargandoC = false; }
  };
  abrirCom = (c: any): void => { this.abiertoCom = this.abiertoCom === c.code ? null : c.code; };
  pagaresDe = (code: string): any[] => this.rc.pagares.filter((p: any) => p.code === code);
  sumaPagares = (code: string): number => Math.round(this.pagaresDe(code).reduce((s, p) => s + (Number(p.financiado) || 0), 0) * 100) / 100;

  excelConsolidado = async (): Promise<void> => {
    try {
      const blob = await this.liq.excelConsolidado(this.fc);
      guardarArchivo(blob, `consolidado-por-comercio-${this.fc.desde}-a-${this.fc.hasta}.xlsx`);
    } catch (e: any) { this.error = 'No se pudo descargar el Excel.'; }
  };

  private hoy(): string { return new Date(Date.now() - 4 * 3600e3).toISOString().slice(0, 10); }
  private mover(dia: string, n: number): string { const d = new Date(`${dia}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }

  /** Atajos de la maqueta: hoy, 7 días, este mes, mes anterior. */
  atajo = (k: 'hoy' | '7' | 'mes' | 'ant', buscar = true): void => {
    const h = this.hoy();
    if (k === 'hoy') { this.f.desde = h; this.f.hasta = h; }
    if (k === '7') { this.f.desde = this.mover(h, -6); this.f.hasta = h; }
    if (k === 'mes') { this.f.desde = `${h.slice(0, 7)}-01`; this.f.hasta = h; }
    if (k === 'ant') {
      const d = new Date(`${h.slice(0, 7)}-01T12:00:00Z`); d.setUTCDate(0);
      this.f.hasta = d.toISOString().slice(0, 10); this.f.desde = `${this.f.hasta.slice(0, 7)}-01`;
    }
    if (buscar) this.buscar();
  };
  esAtajo = (k: 'hoy' | '7' | 'mes' | 'ant'): boolean => {
    const g = { ...this.f }; this.atajo(k, false); const ok = g.desde === this.f.desde && g.hasta === this.f.hasta; this.f.desde = g.desde; this.f.hasta = g.hasta; return ok;
  };
  get hayFiltros(): boolean { return !!(this.f.comercio || this.f.estado || this.f.metodo || this.f.origen || this.f.por !== 'corte'); }
  limpiar = (): void => { this.f = { ...this.f, por: 'corte', comercio: '', estado: '', metodo: '', origen: '' }; this.buscar(); };

  buscar = async (): Promise<void> => {
    this.cargando = true; this.error = ''; this.abierta = null; this.d = null; this.pagina = 0;
    try { this.r = await this.liq.historial(this.f); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el historial.'; this.r = { filas: [], resumen: {} }; }
    finally { this.cargando = false; }
  };

  /** El pie suma el neto de todas las filas del resultado (también lo pasado a mañana). */
  get totalFilas(): number { return Math.round(this.r.filas.reduce((s: number, f: any) => s + (Number(f.neto) || 0), 0) * 100) / 100; }
  get paginas(): number { return Math.max(1, Math.ceil(this.r.filas.length / this.POR)); }
  get visibles(): any[] { return this.r.filas.slice(this.pagina * this.POR, this.pagina * this.POR + this.POR); }
  clave = (f: any): string => f.code || `${f.cierre}-${f.comercio}`;

  /** HIS-05: abre la liquidación en la fila (sus pagarés y su historia). Las del cierre no tienen detalle guardado. */
  detalle = async (f: any): Promise<void> => {
    const k = this.clave(f);
    if (this.abierta === k) { this.abierta = null; this.d = null; return; }
    this.abierta = k; this.d = null;
    if (f.tipo !== 'LIQUIDACION') return;
    try { this.d = await this.liq.liquidacion(f.code); } catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer la liquidación.'; }
  };

  excel = async (): Promise<void> => {
    try {
      const blob = await this.liq.excelHistorial(this.f);
      guardarArchivo(blob, `historial-liquidaciones-${this.f.desde}-a-${this.f.hasta}.xlsx`);
    } catch (e: any) { this.error = 'No se pudo descargar el Excel.'; }
  };

  estado = (s: string): { texto: string; clase: string } => ({
    PAGADA: { texto: 'Pagada', clase: 'kb-badge-exito' }, APROBADA: { texto: 'Aprobada sin pagar', clase: 'kb-badge-alerta' },
    NO_PROCESADA: { texto: 'No procesada', clase: 'kb-badge-peligro' }, PASADA_A_MANANA: { texto: 'Pasada a mañana', clase: 'kb-badge-neutro' },
    POR_LIQUIDAR: { texto: 'Por liquidar', clase: 'kb-badge-contorno' },
  } as any)[s] || { texto: s, clase: 'kb-badge-neutro' };
  readonly ACCION: any = {
    PREPARAR: 'Preparó', INCLUIR: 'Revisada: incluir', ARMAR_LOTE: 'Armó el lote', GENERAR: 'Generó el archivo', DESCARGAR: 'Descargó el Excel', CAMBIAR_CUENTA_ORIGEN: 'Cambió la cuenta origen',
    MARCAR_EN_TANDA: 'Marcada en tanda', APROBAR: 'Aprobada', DEVOLVER: 'Devuelta', ENVIAR_AL_BANCO: 'Enviada al banco', CARGAR_RESPUESTA: 'Respuesta del banco',
    REINTENTAR: 'Propuesta nueva', PASAR_A_MANANA: 'Pasada a mañana o retenida', ANULAR: 'Anulada', AJUSTAR: 'Ajuste', CERRAR: 'Cerrada',
  };
  fecha = (iso: string | null): string => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—');
  hora = (f: any): string => {
    const d = new Date(new Date(f).getTime() - 4 * 3600e3);
    return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')} ${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
  };
}
